import { useState } from "react";

interface IProps<T> {
  initialSearchParam?: T;
}

const useSearchParam = <T,>({ initialSearchParam = {} as T }: IProps<T>) => {
  const [clientSearchParameters, setClientSearchParameters] =
    useState<T>(initialSearchParam);

  const [serverSearchParameters, setServerSearchParameters] =
    useState<T>(initialSearchParam);

  const onSubmit = () => {
    setServerSearchParameters((_) => ({
      ...clientSearchParameters,
    }));
  };

  const clientSearchParamChangeHandler = (name: string, value: any) => {
    setClientSearchParameters({
      ...clientSearchParameters,
      [name]: value,
    });
  };

  const setClientSearchParametersHandler = (value: T) => {
    setClientSearchParameters(value);
  };

  const resetSearchParams = () => {
    setClientSearchParameters(initialSearchParam);
    // setServerSearchParameters(initialSearchParam);
  };

  return {
    serverSearchParams: serverSearchParameters,
    clientSearchParams: clientSearchParameters,
    clientSearchParamChangeHandler,
    onSubmit,
    resetSearchParams,
    setClientSearchParametersHandler,
  };
};

export default useSearchParam;
